import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, forkJoin, map, of, switchMap } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { CompanyBillingApiService } from "../data-access/company-billing-api.service";
import { ShopApiService } from "../data-access/shop-api.service";
import { ShopActions } from "./shop.actions";

@Injectable()
export class ShopEffects {
    private readonly actions$ = inject(Actions);
    private readonly shopApi = inject(ShopApiService);
    private readonly billingApi = inject(CompanyBillingApiService);
    private readonly translate = inject(TranslateService);

    readonly load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ShopActions.pageOpened),
            switchMap(({ clientId }) =>
                forkJoin({
                    products: this.shopApi.loadProducts(),
                    billing: this.billingApi.load(clientId),
                }).pipe(
                    map(({ products, billing }) =>
                        ShopActions.catalogueLoaded({
                            snapshot: {
                                company: billing.company,
                                products,
                                currentItems: billing.subscriptions.flatMap(
                                    (subscription) => subscription.items ?? []
                                ),
                            },
                        })
                    ),
                    catchError((error: unknown) =>
                        of(
                            ShopActions.catalogueLoadFailed({
                                message:
                                    error instanceof Error
                                        ? error.message
                                        : this.translate.instant(
                                              "billing.errors.requestFailed"
                                          ),
                            })
                        )
                    )
                )
            )
        )
    );
}
